import React, { Component } from 'react';
import './App.css';
import Navbar from './components/Navbar'
import Home from './views/Home'
import Detail from './views/Detail'
import CacheBuster from './ChacheBuster';

import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'

import { PrivateRoute } from './components/PrivateRoute'

class App extends Component {
  render() {
    return (
      <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
      if (loading) return null;
      if (!loading && !isLatestVersion) {
        refreshCacheAndReload()
      }
      return <Router>
        <div className="App">
          <header className="App-header">
            <Navbar></Navbar>
          </header>
          <div className="container-fluid">
            <Switch>
              <Route exact path="/" component={ Home }></Route>
              <Route exact path="/:page" component={ Home }></Route>
              <PrivateRoute exact path="/details/:id" component={ Detail }></PrivateRoute>
            </Switch>
          </div>
        </div>
      </Router>
        }}

      </CacheBuster>

    );
  }
}

export default App;
